export default "/packs/images/true-adventure-new~6f74584a10a3ab7bbcca17a03f364f4c.png";